exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content[data-v-dccd5922]{width:800px;margin:50px auto 0}.stepOne-form[data-v-dccd5922]{width:360px;margin:50px auto 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-dccd5922&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/pc/stepOne.vue
// module id = 165
// module chunks = 0